// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3pq7x","container":"styles_container__pv5bH","title":"styles_title__1EThQ","wrapper":"styles_wrapper__3QWTO","answer":"styles_answer__2TSRI"};